import roles from './roles';

const assignAllowedRoles = {
  SUPER_ADMIN: [
    roles.SUPER_ADMIN,
    roles.ADMIN,
    roles.MANAGER,
    roles.ANALYST,
    roles.TEAM_LEADER,
    roles.OPERATOR,
    roles.SALE,
    roles.PUBLISHER,
    roles.CUSTOMER,
  ],
  ADMIN: [
    roles.ADMIN,
    roles.MANAGER,
    roles.ANALYST,
    roles.TEAM_LEADER,
    roles.OPERATOR,
    roles.SALE,
  ],
  MANAGER: [roles.MANAGER, roles.ANALYST, roles.TEAM_LEADER, roles.OPERATOR],
  ANALYST: [roles.ANALYST],
  TEAM_LEADER: [roles.TEAM_LEADER, roles.OPERATOR],
  OPERATOR: [roles.TEAM_LEADER, roles.OPERATOR],
};

export default assignAllowedRoles;
